export default __webpack_public_path__ + "static/tag-do-2-dark-0883cac09f8ac2a467d40974fe565c59.png";